export default {
  ENTITY: 'entity',
  SCREENING: 'screening',
};
